/* tslint:disable */
/* eslint-disable */
/**
 * AddOnSelector.Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProjectDto
 */
export interface ProjectDto {
    /**
     * 
     * @type {number}
     * @memberof ProjectDto
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof ProjectDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectDto
     */
    backgroundColor?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProjectDto
     */
    primaryColor?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProjectDto
     */
    secondaryColor?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProjectDto
     */
    termsAndConditionsUrl?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProjectDto
     */
    logotypeUrl?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProjectDto
     */
    projectUrl?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof ProjectDto
     */
    endDate: Date;
    /**
     * 
     * @type {string}
     * @memberof ProjectDto
     */
    supportEmail: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectDto
     */
    orderEmail: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectDto
     */
    header?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProjectDto
     */
    loginText?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProjectDto
     */
    welcomeText?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProjectDto
     */
    thankYouText?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProjectDto
     */
    emailText?: string | null;
}

/**
 * Check if a given object implements the ProjectDto interface.
 */
export function instanceOfProjectDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "endDate" in value;
    isInstance = isInstance && "supportEmail" in value;
    isInstance = isInstance && "orderEmail" in value;

    return isInstance;
}

export function ProjectDtoFromJSON(json: any): ProjectDto {
    return ProjectDtoFromJSONTyped(json, false);
}

export function ProjectDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'backgroundColor': !exists(json, 'backgroundColor') ? undefined : json['backgroundColor'],
        'primaryColor': !exists(json, 'primaryColor') ? undefined : json['primaryColor'],
        'secondaryColor': !exists(json, 'secondaryColor') ? undefined : json['secondaryColor'],
        'termsAndConditionsUrl': !exists(json, 'termsAndConditionsUrl') ? undefined : json['termsAndConditionsUrl'],
        'logotypeUrl': !exists(json, 'logotypeUrl') ? undefined : json['logotypeUrl'],
        'projectUrl': !exists(json, 'projectUrl') ? undefined : json['projectUrl'],
        'endDate': (new Date(json['endDate'])),
        'supportEmail': json['supportEmail'],
        'orderEmail': json['orderEmail'],
        'header': !exists(json, 'header') ? undefined : json['header'],
        'loginText': !exists(json, 'loginText') ? undefined : json['loginText'],
        'welcomeText': !exists(json, 'welcomeText') ? undefined : json['welcomeText'],
        'thankYouText': !exists(json, 'thankYouText') ? undefined : json['thankYouText'],
        'emailText': !exists(json, 'emailText') ? undefined : json['emailText'],
    };
}

export function ProjectDtoToJSON(value?: ProjectDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'backgroundColor': value.backgroundColor,
        'primaryColor': value.primaryColor,
        'secondaryColor': value.secondaryColor,
        'termsAndConditionsUrl': value.termsAndConditionsUrl,
        'logotypeUrl': value.logotypeUrl,
        'projectUrl': value.projectUrl,
        'endDate': (value.endDate.toISOString()),
        'supportEmail': value.supportEmail,
        'orderEmail': value.orderEmail,
        'header': value.header,
        'loginText': value.loginText,
        'welcomeText': value.welcomeText,
        'thankYouText': value.thankYouText,
        'emailText': value.emailText,
    };
}

